import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';
import { isDefined } from '@fi-shared/utils/is-defined';
import { WidgetAdministrateModel } from '@fi-app/widget/model/widget-administrate.model';
import { DndDropEvent } from 'ngx-drag-drop';
import { removeItem } from '@fi-shared/utils/remove-item';

@Component({
    selector: 'fi-appearance-start-page-edit-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-appearance-start-page-edit-layout' },
    standalone: false,
})
export class FiAppearanceStartPageEditLayoutComponent implements OnChanges {
    @Input('widgetAdministrate') widgetAdministrate: WidgetAdministrateModel;
    @Input('widgetAdministrateWidgets') widgetAdministrateWidgets;
    @Input('editStartPageModel') editStartPageModel;
    @Input('widgets') widgets;

    widgetPlaceHolderControl = WidgetPlaceHolderControlModel;
    widgetsTypeMap: any = {};
    placeholders = [];

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.widgets) {
            this.widgetsTypeMap = {};
            this.widgets.forEach((widget) => (this.widgetsTypeMap[widget.WidgetType] = widget));
        }
    }

    onWidgetDrop($event: DndDropEvent, controlCollection: WidgetPlaceHolderControlModel[]) {
        const insertIndex: number = isDefined($event.index) ? $event.index : controlCollection.length;
        if ($event.type === 'control') {
            controlCollection.splice(insertIndex, 0, new WidgetPlaceHolderControlModel($event.data));
        } else if ($event.type == 'widget') {
            const newControl = new WidgetPlaceHolderControlModel({
                WidgetId: $event.data.Id,
                WidgetType: $event.data.WidgetType,
            });
            const filteredWidgets = this.widgets.filter((widget) => widget.Id === newControl.WidgetId);
            if (!!filteredWidgets.length) {
                this.widgetAdministrateWidgets[newControl.ccmInternalId] = filteredWidgets[0];
            }
            controlCollection.splice(insertIndex, 0, newControl);
        }
    }

    selectWidgetControl(widgetControl: WidgetPlaceHolderControlModel) {
        this.editStartPageModel.Layout.SelectedControl = widgetControl;
    }

    onWidgetMoved(controlCollection: WidgetPlaceHolderControlModel[], control: WidgetPlaceHolderControlModel) {
        removeItem(controlCollection, control);
    }

    widgetDragStart() {
        this.editStartPageModel.ShowTrashBin = true;
    }

    widgetDragEnd() {
        this.editStartPageModel.ShowTrashBin = false;
        this.editStartPageModel.Layout.SelectedControl = null;
    }
}
